module.exports = __webpack_public_path__ + "img/qycx-title.12632e2c.png";